import { observer, useLocalObservable } from 'mobx-react';
import ComplexNewsCommonModel from 'common-modules/general/Common/Logic/News/NewsCommon';
import { ResponseSalesInfo } from 'common-modules/general/API/main/types';
import { ResponseHomeNewsList } from 'common-modules/general/API/news/types';
import { RoutesString } from 'common-modules/general/Config/routesString';
import { useHistory } from 'react-router-dom';
import { toJS } from 'mobx';

interface Props {
    newsSection: ResponseSalesInfo | null;
}

const NewsSection = ({ newsSection }: Props) => {
    const history = useHistory();

    const { model: mainModel } = useLocalObservable(() => ({ model: new ComplexNewsCommonModel() }));
    const { model: detailData } = useLocalObservable(() => ({ model: new ComplexNewsCommonModel() }));

    const handleClickNewsItem = (data: ResponseHomeNewsList) => {
        if(data.addrUrl === null) {
            history.push(`${RoutesString.SalesNewsDetail}/?id=${data.noUperWrtSral}`);
        } else {
            window.open(`${data.addrUrl}`);
        };
    }

    const newsTitle = toJS(detailData.detailData.data?.sbjtNtcPlte); // title
    const newsNum = toJS(detailData.detailData.data?.noUperWrtSral); // 게시글 번호
    const newsUrl = toJS(detailData.detailData.data?.addrUrl); // 외부링크

    return (
        <div className='news-list'>
            <a 
            className='news-list-title'
            // onClick={() => handleClickNewsItem()}   
            >
                {newsSection?.news}
            </a>
        </div>
    )
};

export default NewsSection;
